import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Phone, Mail } from 'lucide-react';
interface QAFinalSlideProps {
  content: {
    headline: string;
    contact: {
      name: string;
      website: string;
      phone: string;
      email: string;
    };
  };
}
export function QAFinalSlide({
  content
}: QAFinalSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-16 min-h-[600px] flex flex-col items-center justify-center relative" data-id="element-217">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-12 text-center" data-id="element-218">
        <img src="https://cdn.magicpatterns.com/uploads/8NCm2XruQu52NQS63PYsNZ/VA-Logo_(1).png" alt="Viridia Analytics" className="h-24 w-auto" data-id="element-219" />
      </motion.div>

      <motion.h2 initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.2
    }} className="text-6xl font-bold text-[#1C1C1C] mb-16 text-center" data-id="element-220">
        {content.headline}
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-white p-10 rounded-2xl shadow-xl border border-[#4D4D4D]/10 w-full max-w-2xl" data-id="element-221">
        <h3 className="text-2xl font-bold text-[#017C6D] mb-8 text-center border-b border-gray-100 pb-6" data-id="element-222">
          {content.contact.name}
        </h3>

        <div className="space-y-6" data-id="element-223">
          <div className="flex items-center justify-center gap-4 text-xl text-[#4D4D4D]" data-id="element-224">
            <Globe className="text-[#0FB07D]" data-id="element-225" />
            <span className="font-medium" data-id="element-226">{content.contact.website}</span>
          </div>
          <div className="flex items-center justify-center gap-4 text-xl text-[#4D4D4D]" data-id="element-227">
            <Phone className="text-[#0FB07D]" data-id="element-228" />
            <span className="font-medium" data-id="element-229">{content.contact.phone}</span>
          </div>
          <div className="flex items-center justify-center gap-4 text-xl text-[#4D4D4D]" data-id="element-230">
            <Mail className="text-[#0FB07D]" data-id="element-231" />
            <span className="font-medium" data-id="element-232">{content.contact.email}</span>
          </div>
        </div>
      </motion.div>
    </div>;
}
export default QAFinalSlide;